<template>
  <div class="form-group">
    <label class="custom-label" style="width: 100%">{{labelDesc}}</label>
    <div class="form" style="display: inline-flex;width: 100%">
      <color-picker-component ref="colorPicker"></color-picker-component>
    </div>
  </div>
</template>
<script>

	import ColorPickerComponent from "./Abstract/ColorPicker";

	export default {
		name: 'BoxColorComponent',
		components: {ColorPickerComponent},
		data() {
			return {
				element: null,
				colorValue: '',
				labelDesc: 'color',
				callback: null,
			}
		},
		methods: {
			changeValue() {
        	this.callback();
			},
			setValues(obj) {

				this.colorValue = obj.defaultValue;
				this.element = obj.element;
				this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
				this.callback = obj.callback;

				this.gradient = obj.gradient;

				this.$refs.colorPicker.setValues(obj);
			}
		},
	}
</script>
<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/BoxColor.vue